module.exports = __webpack_public_path__ + "static/media/workAntihumidity9.12a92446.jpg";